import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApprovedPlanogramDTO } from 'src/app/models/approved-planogram';
import { PlanogramApiService } from 'src/app/services/planogram-api.service';
import { ToastService } from 'src/app/services/toasts.service';
import { NgIf, NgFor, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-approve-planogram-modal',
    templateUrl: './approve-planogram-modal.component.html',
    styleUrl: './approve-planogram-modal.component.scss',
    imports: [NgIf, NgFor, FormsModule, DatePipe]
})
export class ApprovePlanogramModalComponent implements OnInit {
  otherApprovedPlanograms: ApprovedPlanogramDTO[] = [];
  loading: boolean = true;
  unapproveOthers: boolean = false; 
  
  constructor(
    public activeModal: NgbActiveModal, 
    private planogramApiService: PlanogramApiService,
    private toastService: ToastService
  ) { }

  ngOnInit(): void {
    this.planogramApiService.findOtherApprovedPlanograms().subscribe({
      next: (data) => {
        this.otherApprovedPlanograms = data || [];
        this.loading = false;
        if(this.otherApprovedPlanograms.length > 0)
          this.unapproveOthers = true;
      },
      error: () => this.loading = false
    });
  }

  openPlanogram(p: any): void {
    const url = `/planogram/${p.id}/${p.stateId}`;
    window.open(url, '_blank');
  }

  confirm(): void {
    this.planogramApiService.approvePlanogram(this.unapproveOthers).subscribe({
      next: (success) => {
        if (success) {
          this.toastService.show('Planogram approved successfully!', {
            classname: `bg-success text-light p-3 fs-5`,
            delay: 3000,
          });
          this.activeModal.close(true);
        }
      }
    });
  }

  cancel(): void{
    this.activeModal.close(null);
  }
}
